import { useQuery } from '@tanstack/react-query';

import { useTRPC, type ApiClient, type PeriodArg, type QueryOutput } from '../../lib/api';

/** `analytics.regiao` — de onde é o público, pelo DDD. Números prontos do servidor (invariante 3). */
export type RegiaoData = QueryOutput<ApiClient['analytics']['regiao']>;
export type Situacao = RegiaoData['situacao'];

/** O recorte de grupos: o workspace inteiro, uma campanha ou um grupo. */
export type RecorteRegiao =
  { kind: 'TODOS' } | { kind: 'CAMPANHA'; id: string } | { kind: 'GRUPO'; id: string };

export function useRegiaoDoPublico(
  workspaceId: string,
  periodo: PeriodArg,
  situacao: Situacao,
  recorte: RecorteRegiao = { kind: 'TODOS' },
) {
  const trpc = useTRPC();
  return useQuery({
    ...trpc.analytics.regiao.queryOptions({
      workspaceId,
      situacao,
      period: typeof periodo === 'string' ? { preset: periodo } : periodo,
      ...(recorte.kind === 'CAMPANHA' ? { campaignId: recorte.id } : {}),
      ...(recorte.kind === 'GRUPO' ? { groupIds: [recorte.id] } : {}),
    }),
    // A região de quem já está nos grupos muda devagar: não precisa do ao vivo de 1 min.
    staleTime: 5 * 60_000,
  });
}
